/** Provider push notification helpers (Phase K). */

export const INCOMING_OFFER_TYPE = 'incoming_offer';

export const ACCEPTED_AUDIO_FORMATS = 'MP3, WAV, M4A/AAC, OGG';

export function isNativePlatform() {
  try {
    const cap = window.Capacitor;
    return Boolean(cap?.isNativePlatform?.());
  } catch {
    return false;
  }
}

export function parseIncomingOfferData(data = {}) {
  if (!data || data.type !== INCOMING_OFFER_TYPE) return null;
  const offerId = data.offer_id;
  const requestId = data.request_id;
  if (!offerId) return null;
  return { offerId, requestId };
}

export function incomingOfferPath(offerId) {
  return `/provider/offers/${offerId}`;
}

export function formatExpiresSeconds(expiresAt) {
  if (!expiresAt) return null;
  const end = new Date(expiresAt).getTime();
  const diff = Math.max(0, Math.floor((end - Date.now()) / 1000));
  return diff;
}

export function validateRingtoneFile(file, maxBytes) {
  if (!file) return { ok: false, error: 'No file selected' };
  const ext = (file.name.split('.').pop() || '').toLowerCase();
  const allowed = ['mp3', 'wav', 'm4a', 'aac', 'ogg'];
  if (!allowed.includes(ext)) {
    return {
      ok: false,
      error: `Unsupported format. Accepted formats: ${ACCEPTED_AUDIO_FORMATS}`,
    };
  }
  if (file.size > maxBytes) {
    return { ok: false, error: `File exceeds maximum size (${Math.round(maxBytes / 1024 / 1024)}MB)` };
  }
  return { ok: true };
}
